import Link from "next/link";
import styles from "~/sass/organisms/Article/ArticleCard.module.scss";
import Image from "next/legacy/image";

export default function ArticleCard({
  title,
  author,
  slug,
  showAuthorContent = true,
}) {
  return (
    <Link
      prefetch={false}
      legacyBehavior
      href={`/articles/${slug}`}
      as={`/articles/${slug}`}
    >
      <a>
        <div className={styles["ArticleCard"]}>
          <h4 className={styles["ArticleCard__heading"]}>{title}</h4>
          {showAuthorContent && (
            <div className={styles["ArticleCard__author-wrapper"]}>
              <Image
                loading="lazy"
                src="/static/images/articles/amber-martinez--sm.1x.jpg"
                alt="Picture of the author"
                width={32}
                height={32}
                className={styles["ArticleCard__image"]}
              />
              <span>{author}</span>
            </div>
          )}
        </div>
      </a>
    </Link>
  );
}
